import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgIf} from '@angular/common';
import {Subject, takeUntil} from 'rxjs';
import {AuthService} from '../../../services/auth.service';
import {User} from '../../../models/user';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UpdateNameModalComponent} from './update-name-modal/update-name-modal.component';
import {UpdateEmailModalComponent} from './update-email-modal/update-email-modal.component';
import {UpdatePasswordModalComponent} from './update-password-modal/update-password-modal.component';
import {PaymentMethodsComponent} from '../../payment-methods/payment-methods.component';
import {UpdateProfileImageModalComponent} from './update-profile-image-modal/update-profile-image-modal.component';
import {ProfileModalComponent} from '../../profile-modal/profile-modal.component';

@Component({
  selector: 'app-settings-account',
  imports: [
    NgIf,
    PaymentMethodsComponent
  ],
  templateUrl: './settings-account.component.html',
  styleUrl: './settings-account.component.scss'
})
export class SettingsAccountComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  // User
  currentUser: User | null = null

  constructor(private modal: NgbModal,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.authService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe(currentUser => {
      if (currentUser) {
        this.currentUser = currentUser;
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  openUpdateNameModal() {
    if (!this.currentUser) return;

    const updateNameModal = this.modal.open(UpdateNameModalComponent, {centered: true})
    updateNameModal.componentInstance.firstName = this.currentUser.firstName
    updateNameModal.componentInstance.lastName = this.currentUser.lastName
  }

  openUpdateEmailModal() {
    if (!this.currentUser) return;

    const updateEmailModal = this.modal.open(UpdateEmailModalComponent, {centered: true})
    updateEmailModal.componentInstance.email = this.currentUser.email
  }

  openUpdatePasswordModal() {
    if (!this.currentUser) return;

    this.modal.open(UpdatePasswordModalComponent, {centered: true})
  }

  openUpdateProfileImageModal() {
    if (!this.currentUser) return;

    const updateProfileImageModal = this.modal.open(UpdateProfileImageModalComponent, {centered: true})
    updateProfileImageModal.componentInstance.image = this.currentUser.image
  }

  openProfileModal() {
    if (!this.currentUser) return;

    const profileModal = this.modal.open(ProfileModalComponent, {centered: true})
    profileModal.componentInstance.currentUser = this.currentUser
    profileModal.componentInstance.profileUserId = this.currentUser._id
  }

}
